import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Footer} from '../../components';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';
import {
  redirectToDataProfessional,
  redirectToTakeYourPicture,
} from '../../ducks/Navigate';

import './styles.scss';

class PhotoTime extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.PhotoTime.title);
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.props.redirectToTakeYourPicture();
  };

  render() {
    return (
      <div className="div-photo-time">
        <div className="header"></div>
        <div className="content">
          <h1 className="title">Hora das fotos</h1>
          <div className="cellphone-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 75.91 121.36"
              fill="#A9A9A9"
            >
              <g>
                <path d="M65.74 0H10.17A10.18 10.18 0 0 0 0 10.17v101a10.19 10.19 0 0 0 10.17 10.18h55.57a10.19 10.19 0 0 0 10.17-10.18v-101A10.19 10.19 0 0 0 65.74 0Zm5.33 111.18a5.34 5.34 0 0 1-5.33 5.34H10.17a5.34 5.34 0 0 1-5.33-5.34v-13h66.23Zm0-17.87H4.84V16.92h66.23Zm0-81.22H4.84v-1.92a5.33 5.33 0 0 1 5.33-5.33h55.57a5.33 5.33 0 0 1 5.33 5.33Z" />
                <path d="M38.44 100.08h-1a7.26 7.26 0 0 0 0 14.51h1a7.26 7.26 0 0 0 0-14.51Zm0 9.67h-1a2.42 2.42 0 1 1 0-4.83h1a2.42 2.42 0 1 1 0 4.83ZM31.37 32.15H19.58a2.42 2.42 0 0 0-2.42 2.42v11.79a2.42 2.42 0 0 0 4.84 0V37h9.37a2.42 2.42 0 0 0 0-4.84ZM31.37 68.9H22v-9.38a2.42 2.42 0 0 0-4.84 0v11.8a2.42 2.42 0 0 0 2.42 2.41h11.79a2.42 2.42 0 1 0 0-4.83ZM56.33 32.15h-11.8a2.42 2.42 0 0 0 0 4.84h9.38v9.37a2.42 2.42 0 1 0 4.83 0V34.57a2.41 2.41 0 0 0-2.41-2.42ZM56.33 57.11a2.41 2.41 0 0 0-2.42 2.41v9.38h-9.37a2.42 2.42 0 1 0 0 4.83h11.79a2.41 2.41 0 0 0 2.41-2.42V59.52a2.41 2.41 0 0 0-2.41-2.41ZM46.9 86.54h-1.69a2.42 2.42 0 1 0 0 4.84h1.69a2.42 2.42 0 1 0 0-4.84ZM66.24 86.54H56.08a2.42 2.42 0 0 0 0 4.84h10.16a2.42 2.42 0 1 0 0-4.84Z" />
              </g>
            </svg>
          </div>
          <div className="info">
            <p className="info-content-smallest">
              Centralize o rosto na marca.
            </p>
            <p className="info-content-smallest">Procure um lugar iluminado</p>
            <p className="info-content-smallest">
              Para isso acessaremos sua câmera.
              <br />
              Se necessário, clique em <strong>"Permitir"</strong>
            </p>
          </div>
        </div>
        <div className="footer-photo-time">
          <Footer
            backHandle={() => {
              this.props.redirectToDataProfessional();
            }}
            nextHandle={() => {
              this.props.redirectToTakeYourPicture();
            }}
            textNext="CONTINUAR"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({auth}) => {
  return {...auth};
};

export default connect(mapStateToProps, {
  redirectToDataProfessional,
  redirectToTakeYourPicture,
})(PhotoTime);
